<template>
	<el-dialog
		:visible.sync="show"
		:append-to-body="true"
		width="560px"
		:close-on-click-modal="false"
		:show-close="false"
		class="dialog_diy"
	>
		<div class="box">
			<div class="b_img">
				<img :src="require('../../../../assets/icon/pblCourse/huishou.png')" />
			</div>
			<div class="b_title">
				<span>通关成功</span>
			</div>
			<div class="b_content">
				<span
					>恭喜，你已完成课程<span class="c1"
						>“{{ courseName }}”</span
						>的学习，稍后可在<span class="c2">“项目列表”</span
						>里进行查看</span
					>
			</div>
			<div class="b_btn">
				<span class="b_b_submit" @click="submit()">确认</span>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		courseName: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			show: false,
		};
	},
	methods: {
		open() {
			this.show = true;
		},
		close() {
			this.show = false;
		},
		submit() {
			this.$emit("submit");
		},
	},
};
</script>

<style scoped>
.dialog_diy >>> .el-dialog {
	/* height: 100%; */
	/* margin: 0 auto !important; */
	border-radius: 10px;
}

.dialog_diy >>> .el-dialog__header {
	background: #fff !important;
	display: none;
}

.dialog_diy >>> .el-dialog__body {
	height: calc(100% - 124px);
	box-sizing: border-box;
	padding: 0px;
	border-radius: 12px;
}

.dialog_diy >>> .el-dialog__title {
	color: #000;
}

.dialog_diy >>> .el-dialog__headerbtn {
	top: 19px;
}

.dialog_diy >>> .el-dialog__headerbtn .el-dialog__close {
	color: #000;
}

.dialog_diy >>> .el-dialog__headerbtn .el-dialog__close:hover {
	color: #000;
}

.dialog_diy >>> .el-dialog__body,
.dialog_diy >>> .el-dialog__footer {
	background: #fff;
}

.box {
	width: 560px;
	height: 400px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.box > div {
	margin: 10px 0;
}

.b_img {
	width: 100px;
	height: 100px;
}

.b_img > img {
	width: 100%;
	height: 100%;
}

.b_title {
	font-size: 24px;
	font-weight: bold;
}

.b_content {
	width: 80%;
	color: #00000099;
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	font-size: 18px;
}
.b_btn {
	display: flex;
}
.b_btn > span {
	width: 150px;
	height: 50px;
	border-radius: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	font-size: 18px;
	margin: 0 10px;
}

.b_b_cancel {
	background-color: #f3f7fd;
}

.b_b_submit {
	background: linear-gradient(90deg, #3673e8 0%, #ad88fd 100%);
	color: #fff;
}

.c1 {
	background-image: -webkit-linear-gradient(90deg, #3673e8 0%, #ad88fd 100%);
	-webkit-background-clip: text;
	font-weight: bold;
	-webkit-text-fill-color: transparent;
}

.c2 {
	color: black;
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/pblCourse/component/successCourseDialog.vue